import * as angular from "angular";
import {IController} from "angular";
import {ConfigurationType} from "../../enums/configurationType.enum";

export class configurationProfilesTableCtrl implements IController {

  infiniteScroll: any;
  type: ConfigurationType;
  onDuplicate: Function;
  onDelete: Function;
  onSetDefault: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('configurationProfilesTable', {
    bindings: {
      infiniteScroll: '<',
      type: '<',
      onDuplicate: '&',
      onDelete: '&',
      onSetDefault: '&'
    },
    template: require('./configuration-profiles-table.html').default,
    controller: configurationProfilesTableCtrl
  });
